/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Welcome_Feature_Resume_TitleInputs */

const en_onboarding_welcome_feature_resume_title = /** @type {(inputs: Onboarding_Welcome_Feature_Resume_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI-tailored resumes`)
};

const de_onboarding_welcome_feature_resume_title = /** @type {(inputs: Onboarding_Welcome_Feature_Resume_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KI-angepasste Lebensläufe`)
};

const fr_onboarding_welcome_feature_resume_title = /** @type {(inputs: Onboarding_Welcome_Feature_Resume_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CV adaptés par IA`)
};

const es_onboarding_welcome_feature_resume_title = /** @type {(inputs: Onboarding_Welcome_Feature_Resume_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Currículums adaptados por IA`)
};

const it_onboarding_welcome_feature_resume_title = /** @type {(inputs: Onboarding_Welcome_Feature_Resume_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Curriculum personalizzati con AI`)
};

const nl_onboarding_welcome_feature_resume_title = /** @type {(inputs: Onboarding_Welcome_Feature_Resume_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI-gerichte CV's`)
};

const pl_onboarding_welcome_feature_resume_title = /** @type {(inputs: Onboarding_Welcome_Feature_Resume_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dostosowane przez AI CV`)
};

const fi_onboarding_welcome_feature_resume_title = /** @type {(inputs: Onboarding_Welcome_Feature_Resume_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI-sovitetut ansioluettelot`)
};

const da_onboarding_welcome_feature_resume_title = /** @type {(inputs: Onboarding_Welcome_Feature_Resume_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI-tilpassede CV'er`)
};

const sv_onboarding_welcome_feature_resume_title = /** @type {(inputs: Onboarding_Welcome_Feature_Resume_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI-anpassade ansökningshandlingar`)
};

/**
* | output |
* | --- |
* | "AI-tailored resumes" |
*
* @param {Onboarding_Welcome_Feature_Resume_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const onboarding_welcome_feature_resume_title = /** @type {((inputs?: Onboarding_Welcome_Feature_Resume_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Welcome_Feature_Resume_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_onboarding_welcome_feature_resume_title(inputs)
	if (locale === "fr") return fr_onboarding_welcome_feature_resume_title(inputs)
	if (locale === "es") return es_onboarding_welcome_feature_resume_title(inputs)
	if (locale === "it") return it_onboarding_welcome_feature_resume_title(inputs)
	if (locale === "nl") return nl_onboarding_welcome_feature_resume_title(inputs)
	if (locale === "pl") return pl_onboarding_welcome_feature_resume_title(inputs)
	if (locale === "fi") return fi_onboarding_welcome_feature_resume_title(inputs)
	if (locale === "da") return da_onboarding_welcome_feature_resume_title(inputs)
	if (locale === "sv") return sv_onboarding_welcome_feature_resume_title(inputs)
	return en_onboarding_welcome_feature_resume_title(inputs)
});